import { Injectable, Injector } from "@angular/core";
import { BaseService } from "./base.service";
import { Observable } from "rxjs";
import { AccountSignatureModel, AccountSignaturesModel } from "src/app/shared/models/account-signature.model";
import { SupportContextService } from "./support-context.service";

@Injectable({
  providedIn: "root"
})
export class AccountSignatureService extends BaseService {
  className = "AccountSignatureService";

  constructor(injector: Injector, private supportContext: SupportContextService) {
    super(injector);
  }

  getSignaturesByAccountId(accountId: number): Observable<AccountSignaturesModel> {
    return this.get<AccountSignaturesModel>(`/v1/accountSignatures/${accountId}`);
  }

  getCurrentAccountSignatures(isReadDataFromSassEnabled: boolean, signatureType?: string): Observable<AccountSignaturesModel> {
    const params: any = {};
    if (signatureType) {
      params.signatureType = signatureType;
    }
    if (this.supportContext.accountId) {
      params.accountId = this.supportContext.accountId;
    }
    return isReadDataFromSassEnabled ?
      this.get<AccountSignaturesModel>(`/v2/accountSignatures/current`, params) :
      this.get<AccountSignaturesModel>(`/v1/accountSignatures/current`);
  }

  getSignatureById(accountSignatureId: number): Observable<AccountSignatureModel> {
    return this.get<AccountSignatureModel>(`/v1/accountSignature/${accountSignatureId}`);
  }

  getSelectedSignatureByCommission(commissionGuid: string): Observable<AccountSignatureModel> {
    return this.get<AccountSignatureModel>(`/v1/accountSignatures/commission/${commissionGuid}`);
  }

  saveSignature(isReadDataFromSassEnabled: boolean, model: AccountSignatureModel) {
    return isReadDataFromSassEnabled ?
      this.post<AccountSignatureModel>('/v2/accountSignature', model) :
      this.post<AccountSignatureModel>('/v1/accountSignature', model);
  }

  deleteSignature(isReadDataToSassEnabled: boolean, accountSignature: AccountSignatureModel): Observable<any> {
    return isReadDataToSassEnabled ?
      this.delete(`/v2/accountSignature/${accountSignature.signatureGuid}`) :
      this.delete(`/v1/accountSignature/${accountSignature.accountSignatureId}`);
  }

  postIsValidateSignature(image: string): Observable<any> {
    return this.post<any>(`/v1/SignatureIntelligence/detectSignature`, {image: image});
  }
}
